
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '@/components/Layout/Layout';
import LocationsHero from '@/components/Locations/LocationsHero';
import OfficeLocations from '@/components/Locations/OfficeLocations';
import LocationsDirectory from '@/components/Locations/LocationsDirectory';
import LocationsStats from '@/components/Locations/LocationsStats';
import LocationsCTA from '@/components/Locations/LocationsCTA';

const LocationsPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>Service Areas | Carolina Trophy Roofs | Eastern North Carolina Coverage</title>
        <meta name="description" content="Carolina Trophy Roofs serves 200+ locations across Eastern NC including Triangle, Coastal, and Outer Banks areas. Professional roofing contractors with comprehensive regional coverage." />
        <meta name="keywords" content="Eastern NC roofing, Triangle roofing contractors, Coastal NC roofing, Outer Banks roofing, roofing service areas, local roofing contractors, NC roof repair" />
        <link rel="canonical" href="https://www.carolinatrophyroofs.com/locations" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Service Areas | Carolina Trophy Roofs | 200+ Eastern NC Locations" />
        <meta property="og:description" content="Comprehensive roofing services across 200+ Eastern NC locations from Triangle to Outer Banks. Local expertise, quality guaranteed." />
        <meta property="og:url" content="https://www.carolinatrophyroofs.com/locations" />
        
        {/* Schema.org Local Business */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Carolina Trophy Roofs",
            "description": "Professional roofing contractor serving Eastern North Carolina",
            "areaServed": [
              { "@type": "State", "name": "North Carolina" },
              { "@type": "City", "name": "Rocky Mount, NC" },
              { "@type": "City", "name": "Greenville, NC" },
              { "@type": "City", "name": "Wilson, NC" },
              { "@type": "City", "name": "Raleigh, NC" },
              { "@type": "City", "name": "Durham, NC" },
              { "@type": "City", "name": "Wilmington, NC" },
              { "@type": "City", "name": "New Bern, NC" },
              { "@type": "City", "name": "Kinston, NC" },
              { "@type": "City", "name": "Elizabeth City, NC" }
            ]
          })}
        </script>
      </Helmet>
      <LocationsHero />

      <LocationsStats />
      
      <div className="container mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="space-y-16">
          <OfficeLocations />
          
          <div>
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">All Service Locations</h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Browse our comprehensive directory of Eastern North Carolina locations. 
                Each area receives specialized service from local teams who understand regional roofing needs.
              </p>
            </div>
            <LocationsDirectory />
          </div>
        </div>
      </div>

      <LocationsCTA />
    </Layout>
  );
};

export default LocationsPage;
